import React, { Component } from 'react';
import BaseClass from '../common/baseClass';
import { createPortal } from 'react-dom'; // Importa createPortal da react-dom
import $ from 'jquery'; // Importa jQuery

import { in_WishList } from 'components/views/WishList';

const common = require('../common/common');

class CartiReplacements extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            articolo: this.props.articolo,
        }
        this.updateStateWithStoreProps();
    }

    componentDidMount() {
        $('#closeModal').click();
        $('#modalReplacements').modal('show');
        $('#modalReplacements').on('hidden.bs.modal', this.handleModalClose);
    }
    

    componentWillUnmount() {
        $('#modalReplacements').off('hidden.bs.modal', this.handleModalClose);
    }

    handleModalClose = () => {
        $('#modalReplacements').modal('hide');
        this.props.handleCloseReplacement();
    }

    render() {
        let qpezz = 0, qcata = 0, qx = 0, prezzo = 0;
        let valuta = "", classeTD = "", arti = "", wishListIndex = '';
        let localeLang = common.getLanguageLocale();
        let non_ordinabile = false;
        return createPortal(
            <div className="modal fade" id="modalReplacements" tabIndex="-1" data-backdrop="static" data-keyboard="true" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modalLabel">{common.getTrad("Selezione Sostitutivi")}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='' id="sostiTableContainer">
                                <table className='tabellaSostitutivi table table-responsive table-striped'>
                                <style id='tabellaSostitutiviBeforeTitle'>{`
                                    .tabellaSostitutivi td:nth-of-type(1) {width: 20% }
                                    .tabellaSostitutivi td:nth-of-type(2) {width: 51%; }
                                    .tabellaSostitutivi td:nth-of-type(3) {width: 7%; }
                                    .tabellaSostitutivi td:nth-of-type(4) {width: 15%; }
                                    .tabellaSostitutivi td:nth-of-type(5) {width: 7%;}

                                    .tabellaSostitutivi th:nth-of-type(1) {width: 20% }
                                    .tabellaSostitutivi th:nth-of-type(2) {width: 51%; }
                                    .tabellaSostitutivi th:nth-of-type(3) {width: 7%; }
                                    .tabellaSostitutivi th:nth-of-type(4) {width: 15%; }
                                    .tabellaSostitutivi th:nth-of-type(5) {width: 7%;}
                                    `
                                }</style>
                                    <thead>
                                    <tr className="tabellaSostitutiviHead">
                                        <th className='displayArti'>{common.getTrad("Codice Articolo")}</th>
                                        <th>{common.getTrad("Descrizione")}</th>
                                        <th>{common.getTrad("Pezzi")}</th>
                                        <th className="gridPrice">{common.getTrad("Prezzo")}</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {   
                                        Object.keys(this.state.data).map((index, key) => {
                                            if (index != "error") {
                                                if (this.state.data[index].ISPADRE === true) {
                                                    //quantità da catalogo
                                                    qcata = this.state.data[index].QPEZZ;
                                                    qpezz = this.state.data[index].QPEZZ;
                                                    valuta = this.state.data[index].CVALU;
                                                }
                                                else if (this.state.data[index].QSOST > 0) {
                                                    qx = this.state.data[index].QSOST;
                                                    qpezz = qx * qcata;
                                                } 

                                                non_ordinabile = (this.state.data[index].TMOVI == "S" || this.state.data[index].FAGGI == "C");
                                                prezzo = this.state.data[index].PRICE;
                                                classeTD = non_ordinabile ? "non_ordinabile" : "";
                                                wishListIndex = in_WishList(this.state.data[index]);

                                                arti = common.cloneFromState(this.state.articolo);
                                                arti.cartiSost = arti.CARTI;
                                                arti.CARTI = this.state.data[index].CARTI;
                                                arti.TMOVI = this.state.data[index].TMOVI;
                                                arti.DARTI = this.state.data[index].DARTI;
                                                arti.PRICE = prezzo;
                                                return (
                                                    <tr className='table-row' key={key} >
                                                        <td className={classeTD + " displayArti"}>{this.state.data[index].CARTI}</td>
                                                        <td className={classeTD}>{this.state.data[index].DARTI}</td>
                                                        <td className={classeTD}>{qpezz}</td>
                                                        <td className={classeTD + " gridPrice"}>{prezzo.toLocaleString(localeLang, { style: 'currency', currency: valuta })}</td>
                                                        {non_ordinabile ?
                                                            (
                                                                <td className={classeTD} />
                                                            )
                                                            :
                                                            (
                                                                <td style={{ cursor: "pointer" }} className={("animated articoloRow_" + key) + " " + classeTD + " buttonAddArticoloCarrello colonnaAzioniRigaTabellaDX "} onClick={(e)=> {
                                                                    e.stopPropagation();
                                                                    this.props.handleEditWishlistClick(arti);
                                                                    $('#modalReplacements').modal('hide');
                                                                }
                                                                }>
                                                                    <span>
                                                                        <i className="fas fa-cart-plus"></i>
                                                                        <sup style={{ visibility: (wishListIndex > -1 ? "visible" : "hidden") }}>
                                                                            <i className="fas fa-check-circle justWished"></i>
                                                                        </sup>
                                                                    </span>
                                                                </td>
                                                            )
                                                        }
                                                    </tr>
                                                );
                                            }
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light" data-dismiss="modal">{common.getTrad("Annulla")}</button>
                        </div>
                    </div>
                </div>
            </div>,
            document.body
        );
    }
}
export default CartiReplacements;